import {createSelector} from '@ngxs/store';
import {NavService} from '../services/nav.service';

export class SharedSelectors {
    static getBreadcrumbs(routerStateClass, currentUserStateClass) {
        return createSelector([routerStateClass, currentUserStateClass], (routerState, currentUser) => {
            let breadcrumbs;
            const {root} = routerState;
            if (root) {
                breadcrumbs = NavService.getBreadcrumbs(root, currentUser);
            }
            return breadcrumbs.filter(Boolean);
        });
    }
}
